import { createAsyncThunk } from "@reduxjs/toolkit";
import SupportApiService from "../apiServices/SupportApiService";
import { SupportAnswer, Turn } from "../../interfaces/SupportObject";

/** No known backend error codes to map yet — surface whatever message
 *  SupportApiService (extractApiErrorMessage) or a network failure produced. */
function toFriendlySupportError(error: unknown): string {
  return error instanceof Error
    ? error.message
    : "Something went wrong. Please try again.";
}

export interface AskSupportArg {
  question: string;
  /** Prior turns only — excludes this question, per the API contract. */
  history: Turn[];
  /** id of the optimistic user bubble, so the slice can flip that exact
   *  message to "error" on rejection without guessing which one it was. */
  userMessageId: string;
}

export const askSupport = createAsyncThunk<SupportAnswer, AskSupportArg>(
  "supportChat/askSupport",
  async (arg, { rejectWithValue }) => {
    try {
      return await SupportApiService.askSupport(arg.question, arg.history);
    } catch (error) {
      return rejectWithValue(toFriendlySupportError(error));
    }
  }
);

const SupportThunk = { askSupport };

export default SupportThunk;
